import { render } from "./piece.vue?vue&type=template&id=758e47eb&scoped=true"
import script from "./piece.vue?vue&type=script&lang=js"
export * from "./piece.vue?vue&type=script&lang=js"

import "./piece.vue?vue&type=style&index=0&id=758e47eb&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp8c0m8ga1zm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758e47eb"]])

export default __exports__